import {
  merge, concat, reject, propEq
} from 'ramda';
import {
  SUCCESS,
  FAIL,
  REQUEST,
  EVENTS_FAIL,
  EVENTS_SUCCESS,
  EVENTS_REQUEST,
  RECURRING_TYPES_SUCCESS,
  WORK_DAY_EVENT_TYPES_SUCCESS,
  SUBMIT_REQUEST,
  SUBMIT_SUCCESS,
  SUBMIT_FAIL,
  DELETE_SUCCESS,
  DELETE_FAIL,
  DELETE_REQUEST,
  UPDATE_SUCCESS,
  UPDATE_REQUEST,
  UPDATE_FAIL
} from 'src/store/actions/workDayEventsActions';

const initialState = {
  workDays: {},
  list: [],
  recurringTypes: {},
  eventTypes: {},
  fetching: false,
  errors: []
};

const workDayEventsReducer = (state = initialState, action) => {
  switch (action.type) {
    case REQUEST:
      return merge(state, { fetching: true });
    case SUCCESS:
      return merge(state, { workDays: action.workDays, fetching: false, errors: [] });
    case FAIL:
      return merge(state, { fetching: false, errors: [action.error] });
    case EVENTS_REQUEST:
      return merge(state, { fetching: true });
    case EVENTS_SUCCESS:
      return merge(state, { list: action.events, fetching: false, errors: [] });
    case EVENTS_FAIL:
      return merge(state, { fetching: false, errors: [action.error] });
    case RECURRING_TYPES_SUCCESS:
      return merge(state, { recurringTypes: action.types, fetching: false });
    case WORK_DAY_EVENT_TYPES_SUCCESS:
      return merge(state, { eventTypes: action.types, fetching: false });
    case SUBMIT_REQUEST:
      return merge(state, { fetching: true });
    case SUBMIT_SUCCESS:
      return merge(state, { list: concat(state.list, action.workDay), fetching: false, errors: [] });
    case SUBMIT_FAIL:
      return merge(state, { fetching: false, errors: [action.error] });
    case UPDATE_REQUEST:
      return merge(state, { fetching: true });
    case UPDATE_SUCCESS:
      return merge(
        state,
        { list: concat(reject(propEq('Id', action.workDay[0].Id), state.list), action.workDay), fetching: false, errors: [] }
      );
    case UPDATE_FAIL:
      return merge(state, { fetching: false, errors: [action.error] });
    case DELETE_REQUEST:
      return merge(state, { fetching: true });
    case DELETE_SUCCESS:
      return merge(state, { list: reject(propEq('Id', action.workDayId), state.list), fetching: false, errors: [] });
    case DELETE_FAIL:
      return merge(state, { fetching: false, errors: [action.error] });
    default:
      return state;
  }
};

export default workDayEventsReducer;
